<template>
  <div class='security'>
    <monitorHead title="网站安全性"
                 :img="img"
                 :text="text"></monitorHead>
    <div class="security_body">
      <div class='security_item'>
        <div :class='`left ${details.httpsFlag ? "correct" : "error"}`'>
          <!-- 对接 -->
          <ig-icon name="a-bianzu311"
                   style="color:#3DA1FF"
                   v-if="details.httpsFlag"></ig-icon>
          <ig-icon name="igw-f-lock-on"
                   style="color:#ED4F28"
                   v-else></ig-icon>
        </div>
        <div class='right'>
          <div class='text'>您{{details.httpsFlag ? '已' : '未'}}启用安全证书</div>
          <div class='tips'>全站HTTPS可以有效防劫持与保护用户隐私安全</div>
        </div>
      </div>
      <div class='security_item'>
        <div :class='`left ${details.safetyFlag ? "correct" : "error"}`'>
          <ig-icon name="a-anquan2"
                   style="color:#3DA1FF"
                   v-if="details.safetyFlag"></ig-icon>
          <ig-icon name="fengxian"
                   style="color:#ED4F28"
                   v-else></ig-icon>
        </div>
        <div class='right'>
          <div class='text'>网站{{details.safetyFlag ? '不' : ''}}存在被黑风险</div>
          <div class='tips'>服务器空间商的安全或网站程序的安全自身的程序安全漏洞被黑被入侵被挂马</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import monitorHead from './monitorHead';
import img from '@/assets/websiteMonitor/networkSecurity.png';
export default {
  name: 'security',
  props: ['details'],
  components: {
    monitorHead
  },
  data () {
    return {
      img,
      text: '全球赢网站上线即自动配置SSL安全证书，保证用户的访问数据隐私安全，全球赢网站采用安全可靠的海外服务器，防止网站数据被劫持，据统计标记安全的网站可以提升用户60%的访问率。'
    }
  },
}
</script>

<style lang='scss' scoped>
.security {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;
	padding: 0 100px 50px;

	.security_body {
		display: flex;
		width: 100%;
		padding: 0 150px;
	}

	.security_item {
		display: flex;
		flex: 1;
		align-items: center;
		margin-top: 20pt;

		.left {
			width: 90px;
			height: 90px;
			border-radius: 50%;

			.iconfont {
				font-size: 30px;
			}
		}

		.right {
			flex: 1;
			width: 0;
			margin-left: 20px;

			.text {
				font-weight: 600;
				font-size: 20px;
			}

			.tips {
				margin-top: 10px;
				font-size: 14px;
        color: #666666;
			}
		}
	}

	.error,
	.correct {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.error {
		background-color: #fbdcd4;
	}

	.correct {
		background-color: #3da1ff50;
	}
}
</style>
